import { Link } from '@remix-run/react'
import { type ReactNode } from 'react'

type Section = { id: string; title: string }

export const MobileToc = ({ sections, children }: { sections: Section[]; children?: ReactNode }) => (
	<div className="border-y border-muted-200 py-8 lg:hidden">
		<nav>
			<p className="text-size-sm font-semibold text-muted-900">In this article</p>
			<ol className="mt-4 grid grid-cols-1 gap-y-2 text-size-sm">
				{sections.map((section, i) => (
					<li key={section.id}>
						<Link to={`#${section.id}`} className="text-muted-600 transition-colors hover:text-brand">
							<span className="mr-2 text-muted-300 dark:text-muted-600">{String(i + 1).padStart(2, '0')}</span>
							{section.title}
						</Link>
					</li>
				))}
			</ol>
			{children}
		</nav>
	</div>
)

export const SidebarToc = ({ sections, children }: { sections: Section[]; children?: ReactNode }) => (
	<aside className="hidden lg:block">
		<nav className="sticky top-24 w-48">
			<p className="text-xs font-semibold text-muted-900">In this article</p>
			<ol className="mt-4 space-y-2">
				{sections.map((section, i) => (
					<li key={section.id}>
						<Link to={`#${section.id}`} data-section={section.id} className="toc-link block text-xs leading-snug">
							<span className="toc-number mr-1.5">{String(i + 1).padStart(2, '0')}</span>
							<span className="toc-title">{section.title}</span>
						</Link>
					</li>
				))}
			</ol>
			{children}
		</nav>
	</aside>
)
